(function (host, factory) {
  'use strict';
  var library = factory();
  if (typeof module === 'object' && module.exports) module.exports = library;
  else if (host && host.document) {
    if (host.FASGardenLetters && host.FASGardenLetters.version === library.version) host.FASGardenLetters.initialize();
    else {
      if (host.FASGardenLetters && host.FASGardenLetters.dispose) host.FASGardenLetters.dispose();
      host.FASGardenLetters = library.createRuntime(host);
    }
  }
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  var VERSION = '5.8.0';
  var TONES = ['Neutro', 'Rosado', 'Variado'];
  var NATIVE_TONES = { A: 'Rosado', C: 'Neutro', M: 'Variado' };
  var DEFAULT_NOTE = 'Haz clic aquí para personalizar';
  function normalizedSelection(values) {
    values = values || {};
    function letter(value, fallback) {
      var text = String(value || '').trim().normalize('NFC').toUpperCase();
      return /^[A-Z0-9]$/.test(text) ? text : fallback;
    }
    var offer = String(values.offer || 'pareja-xl');
    if (['single', 'pareja', 'pareja-xl'].indexOf(offer) < 0) offer = 'pareja-xl';
    var rawMessage = String(values.message || '');
    return {
      offer: offer, pair: offer !== 'single', size: offer === 'pareja-xl' || (offer === 'single' && values.size === 'large') ? '19' : '10',
      letter1: letter(values.letter1, 'A'), letter2: letter(values.letter2, 'C'),
      tone1: TONES.indexOf(values.tone1) >= 0 ? values.tone1 : 'Rosado',
      tone2: TONES.indexOf(values.tone2) >= 0 ? values.tone2 : 'Neutro',
      noteEnabled: offer === 'pareja-xl' || values.noteEnabled === true || values.noteEnabled === 'yes',
      theme1: values.theme1 || 'Sin Temática', theme2: values.theme2 || 'Sin Temática',
      message: offer === 'pareja-xl' || values.noteEnabled === true || values.noteEnabled === 'yes' ? rawMessage.trim() : '', messageLength: rawMessage.length
    };
  }
  function containAtBaseline(width, height, canvasWidth, canvasHeight, supportRatio) {
    if (![width, height, canvasWidth, canvasHeight].every(function (value) { return Number.isFinite(value) && value > 0; })) return null;
    var scale = Math.min(canvasWidth * .96 / width, canvasHeight * .89 / height);
    var w = width * scale, h = height * scale;
    var support = Number.isFinite(supportRatio) && supportRatio >= .88 && supportRatio <= 1 ? supportRatio : 1;
    return { x: (canvasWidth - w) / 2, y: canvasHeight * .93 - h * support, width: w, height: h };
  }
  function supportFromAlpha(pixels, width, height) {
    if (!pixels || pixels.length < width * height * 4 || width < 1 || height < 6) return 1;
    // Compare only the lower body: a 4's crossbar or a Q's tail must not
    // define the density threshold for the whole letter.
    var rows = [], start = Math.floor(height * .88), peak = 0;
    for (var y = Math.max(0, start - 2); y < height; y++) {
      var count = 0;
      for (var x = 0; x < width; x++) if (pixels[(y * width + x) * 4 + 3] > 160) count++;
      rows[y] = count;
    }
    for (var row = start; row < height - 2; row++) {
      var density = (rows[row - 2] + rows[row - 1] + rows[row] + rows[row + 1] + rows[row + 2]) / 5;
      peak = Math.max(peak, density);
    }
    if (peak < 1) return 1;
    var last = height - 1;
    for (var index = start; index < height - 2; index++) {
      var mass = (rows[index - 2] + rows[index - 1] + rows[index] + rows[index + 1] + rows[index + 2]) / 5;
      if (mass >= peak * .5) last = index;
    }
    return Math.max(.88, Math.min(1, (last + .5) / height));
  }
  function boundsFromAlpha(pixels, width, height, padding) {
    if (!Number.isInteger(width) || !Number.isInteger(height) || width < 1 || height < 1 || !pixels || pixels.length < width * height * 4) return null;
    var left = width, top = height, right = -1, bottom = -1;
    for (var y = 0; y < height; y++) for (var x = 0; x < width; x++) {
      if (pixels[(y * width + x) * 4 + 3] < 10) continue;
      left = Math.min(left, x); right = Math.max(right, x); top = Math.min(top, y); bottom = Math.max(bottom, y);
    }
    if (right < left || bottom < top) return null;
    padding = padding === undefined ? 2 : Math.max(0, Number.isFinite(padding) ? Math.floor(padding) : 0);
    left = Math.max(0, left - padding); top = Math.max(0, top - padding);
    right = Math.min(width - 1, right + padding); bottom = Math.min(height - 1, bottom + padding);
    return { x: left, y: top, width: right - left + 1, height: bottom - top + 1 };
  }
  function rectangle(value) {
    if (!value || typeof value !== 'object') return null;
    var rect = { x: value.x, y: value.y, width: value.width, height: value.height };
    return Object.values(rect).every(Number.isInteger) && rect.x >= 0 && rect.y >= 0 && rect.width > 0 && rect.height > 0 ? rect : null;
  }
  function within(rect, width, height) {
    return rect && rect.x + rect.width <= width && rect.y + rect.height <= height;
  }
  function safeURL(value, base) {
    if (typeof value !== 'string' || !value.trim()) return null;
    try {
      var url = new URL(value, base);
      return /^https?:$/.test(url.protocol) && !url.username && !url.password ? url.href : null;
    } catch (_) { return null; }
  }
  function parseLibrary(value, base) {
    if (typeof value === 'string') { try { value = JSON.parse(value); } catch (_) { value = null; } }
    var entries = new Map();
    if (!value || value.version !== 1 || !value.glyphs || typeof value.glyphs !== 'object') return entries;
    TONES.forEach(function (tone) {
      var group = value.glyphs[tone];
      if (!group || typeof group !== 'object') return;
      Object.keys(group).forEach(function (letter) {
        if (!/^[A-Z0-9]$/.test(letter)) return;
        var item = group[letter];
        if (typeof item === 'string') item = { url: item };
        if (!item || typeof item !== 'object') return;
        var url = safeURL(item.url, base), crop = item.crop === undefined ? null : rectangle(item.crop);
        var bounds = item.bounds === undefined ? null : rectangle(item.bounds);
        if (!url || (item.crop !== undefined && !crop) || (item.bounds !== undefined && !bounds) || (crop && bounds && !within(bounds, crop.width, crop.height))) return;
        entries.set(letter + ':' + tone, { url: url, crop: crop, bounds: bounds, source: item.source === 'original' ? 'original' : 'generated', tone: tone, supportRatio: Number.isFinite(item.supportRatio) && item.supportRatio >= .88 && item.supportRatio <= 1 ? item.supportRatio : 1 });
      });
    });
    return entries;
  }
  function cutoutKey(letter, tone) {
    return Object.prototype.hasOwnProperty.call(NATIVE_TONES, letter) && NATIVE_TONES[letter] === tone ? 'cutout' + letter : null;
  }
  function usesIntegratedPhotograph(state, mode) {
    if (!state.pair) return mode !== 'custom' && state.letter1 === 'A' && state.tone1 === 'Rosado' && (!state.theme1 || state.theme1 === 'Sin Temática');
    return mode !== 'custom' && state.pair && state.letter1 === 'A' && state.letter2 === 'C' && state.tone1 === 'Rosado' && state.tone2 === 'Neutro' && (!state.theme1 || state.theme1 === 'Sin Temática') && (!state.theme2 || state.theme2 === 'Sin Temática');
  }
  function descriptorFor(entries, sources, letter, tone, base) {
    var key = letter + ':' + tone;
    if (entries.has(key)) return entries.get(key);
    var native = cutoutKey(letter, tone), url = native && safeURL(sources[native], base);
    return url ? { url: url, crop: null, bounds: null, source: 'original', tone: tone } : null;
  }
  function sourceRectangle(item, width, height, measured) {
    if (!item || !Number.isInteger(width) || !Number.isInteger(height) || width < 1 || height < 1) return null;
    var crop = rectangle(item.crop || { x: 0, y: 0, width: width, height: height });
    var bounds = rectangle(item.bounds || measured);
    if (!within(crop, width, height) || !bounds || !within(bounds, crop.width, crop.height)) return null;
    return { x: crop.x + bounds.x, y: crop.y + bounds.y, width: bounds.width, height: bounds.height };
  }
  function createImageStore(win, options) {
    options = options || {};
    var records = new Map(), wanted = new Set(), dead = false, active = 0;
    var limit = options.limit || 6, maxActive = options.maxActive || 2, timeout = options.timeout || 15000;
    var retryDelay = options.retryDelay || 1400, maxAttempts = options.maxAttempts || 2;
    function signal() { if (!dead && options.onChange) options.onChange(); }
    function touch(record) { records.delete(record.url); records.set(record.url, record); return record; }
    function finishPromise(record) { if (record.resolve) { record.resolve(record); record.resolve = null; } }
    function clearTimers(record) {
      if (record.timer !== null) win.clearTimeout(record.timer);
      if (record.retryTimer !== null) win.clearTimeout(record.retryTimer);
      record.timer = null; record.retryTimer = null;
    }
    function prune() {
      records.forEach(function (record, url) {
        if (records.size <= limit || wanted.has(url) || record.state === 'loading') return;
        clearTimers(record); record.state = record.state === 'ready' ? 'ready' : 'cancelled';
        finishPromise(record); records.delete(url);
      });
    }
    function start(record) {
      active++; record.attempts++; record.state = 'loading';
      var image = new win.Image(), finished = false;
      record.image = image; image.crossOrigin = 'anonymous'; image.decoding = 'async';
      function complete(ok) {
        if (finished || dead) return;
        finished = true; active--; clearTimers(record); image.onload = null; image.onerror = null;
        ok = ok && image.naturalWidth > 0 && image.naturalHeight > 0 && image.naturalWidth <= 8192 && image.naturalHeight <= 8192 && image.naturalWidth * image.naturalHeight <= 33554432;
        if (ok) { record.state = 'ready'; record.revision++; finishPromise(record); }
        else if (wanted.has(record.url) && record.attempts < maxAttempts) {
          record.state = 'retrying';
          record.retryTimer = win.setTimeout(function () {
            record.retryTimer = null;
            if (dead) return;
            if (wanted.has(record.url)) { record.state = 'queued'; pump(); }
            else { record.state = 'failed'; finishPromise(record); }
          }, retryDelay);
        } else { record.state = 'failed'; finishPromise(record); }
        prune(); signal(); pump();
      }
      image.onload = function () { complete(true); }; image.onerror = function () { complete(false); };
      record.timer = win.setTimeout(function () { complete(false); }, timeout);
      try { image.src = record.url; } catch (_) { complete(false); }
    }
    function pump() {
      if (dead) return;
      records.forEach(function (record) { if (active < maxActive && record.state === 'queued' && wanted.has(record.url)) start(record); });
    }
    function request(url) {
      if (dead) return null;
      if (records.has(url)) return touch(records.get(url));
      var record = { url: url, image: null, state: 'queued', attempts: 0, revision: 0, timer: null, retryTimer: null, promise: null, resolve: null, bounds: new Map() };
      record.promise = new Promise(function (resolve) { record.resolve = resolve; });
      records.set(url, record); prune(); pump(); return record;
    }
    function setWanted(urls) {
      wanted = new Set(urls);
      records.forEach(function (record, url) {
        if (!wanted.has(url) && ['queued', 'retrying'].indexOf(record.state) >= 0) {
          clearTimers(record); record.state = 'cancelled'; finishPromise(record); records.delete(url);
        }
      });
      wanted.forEach(request); prune(); pump();
    }
    function retry() {
      if (dead) return;
      wanted.forEach(function (url) {
        var record = records.get(url);
        if (record && record.state === 'failed') { records.delete(url); request(url); }
      });
      pump(); signal();
    }
    function dispose() {
      if (dead) return; dead = true;
      records.forEach(function (record) {
        clearTimers(record);
        if (record.image) { record.image.onload = null; record.image.onerror = null; }
        if (record.state !== 'ready') record.state = 'cancelled'; finishPromise(record);
      });
      records.clear(); wanted.clear();
    }
    return { setWanted: setWanted, get: function (url) { return records.has(url) ? touch(records.get(url)) : null; }, request: request, retry: retry, dispose: dispose, size: function () { return records.size; } };
  }
  function createRuntime(win) {
    var doc = win.document, controllers = new Map(), globalRemovers = [], disposed = false;
    function listen(target, type, callback, removers) {
      if (!target || !target.addEventListener) return;
      target.addEventListener(type, callback); removers.push(function () { target.removeEventListener(type, callback); });
    }
    function initialize(scope, excludedSection) {
      if (disposed) return api;
      scope = scope || doc;
      var roots = Array.from(scope.querySelectorAll('[data-fas-garden]'));
      if (scope.matches && scope.matches('[data-fas-garden]')) roots.unshift(scope);
      function included(element) { return !excludedSection || (element !== excludedSection && !excludedSection.contains(element)); }
      roots.forEach(function (root) {
        if (controllers.has(root) || !included(root)) return;
        function owned(selector) { return Array.from(root.querySelectorAll(selector)).filter(included); }
        var form = owned('[data-fas-form]')[0], sourceNode = owned('[data-fas-textures]')[0], libraryNode = owned('[data-fg-letter-library]')[0];
        if (!form) return;
        var sources;
        try { sources = JSON.parse(sourceNode && sourceNode.textContent || '{}'); } catch (_) { sources = {}; }
        if (!sources || typeof sources !== 'object') sources = {};
        var entries = parseLibrary(libraryNode && libraryNode.textContent, doc.baseURI);
        var themeNode = owned('[data-fg-theme-assets]')[0];
        var themeSources = win.FASGardenCharms?.parseSources(themeNode && themeNode.textContent, doc.baseURI) || {};
        var removers = [], frame = null, dead = false, broadcast = false, selectionSignature = '';
        var notes = owned('[data-fg-note-text]'), cards = owned('[data-fg-note]'), counters = owned('[data-fas-message-count]');
        var letterStatus = owned('[data-fg-letter-status]')[0];
        var store = createImageStore(win, { onChange: function () { schedule(false); } });
        var views = owned('[data-fg-letter]').map(function (button) {
          var canvas = button.querySelector('[data-fg-letter-canvas]'), number = button.getAttribute('data-fg-letter');
          if (!canvas || !/^[12]$/.test(number)) return null;
          canvas.width = Math.max(1, Math.min(1200, Number(canvas.getAttribute('width')) || 900));
          canvas.height = Math.max(1, Math.min(1400, Number(canvas.getAttribute('height')) || 700));
          var context = canvas.getContext('2d');
          if (context) { context.imageSmoothingEnabled = true; context.imageSmoothingQuality = 'high'; }
          return { button: button, canvas: canvas, cast: button.querySelector('[data-fg-letter-cast]'), contact: button.querySelector('[data-fg-letter-contact]'), context: context, number: number, fallback: button.querySelector('[data-fg-letter-fallback]'), signature: '', painted: false, issue: '' };
        }).filter(Boolean);
        function read() {
          var data = new win.FormData(form), values = {};
          ['offer', 'size', 'letter1', 'letter2', 'tone1', 'tone2', 'theme1', 'theme2', 'message', 'noteEnabled'].forEach(function (key) { values[key] = data.get(key); });
          return normalizedSelection(values);
        }
        function bounds(item, record) {
          var image = record.image;
          var crop = item.crop || { x: 0, y: 0, width: image.naturalWidth, height: image.naturalHeight };
          if (!within(crop, image.naturalWidth, image.naturalHeight)) return null;
          if (item.bounds) return sourceRectangle(item, image.naturalWidth, image.naturalHeight);
          var key = JSON.stringify(crop);
          if (!record.bounds.has(key)) {
            var probe = doc.createElement('canvas'); probe.width = crop.width; probe.height = crop.height;
            try {
              var context = probe.getContext('2d', { willReadFrequently: true });
              if (!context) throw new Error('No canvas');
              context.drawImage(image, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
              record.bounds.set(key, boundsFromAlpha(context.getImageData(0, 0, crop.width, crop.height).data, crop.width, crop.height));
            } catch (_) { record.bounds.set(key, null); }
            finally { probe.width = 1; probe.height = 1; }
          }
          return sourceRectangle(item, image.naturalWidth, image.naturalHeight, record.bounds.get(key));
        }
        function typography(view, letter, tone) {
          var context = view.context;
          if (!context) return false;
          context.clearRect(0, 0, view.canvas.width, view.canvas.height); context.font = 'bold 560px Arial, sans-serif';
          var metrics = context.measureText(letter), ascent = metrics.actualBoundingBoxAscent || 410;
          var descent = Math.max(0, metrics.actualBoundingBoxDescent || 0), left = metrics.actualBoundingBoxLeft || 0;
          var target = containAtBaseline(left + (metrics.actualBoundingBoxRight || metrics.width), ascent + descent, view.canvas.width, Math.min(700, view.canvas.height));
          if (!target) return false;
          var scale = target.height / (ascent + descent);
          context.font = 'bold ' + (560 * scale) + 'px Arial, sans-serif'; context.textAlign = 'left'; context.textBaseline = 'alphabetic';
          context.fillStyle = tone === 'Rosado' ? '#b77792' : tone === 'Variado' ? '#b69458' : '#e4d9bd';
          context.fillText(letter, target.x + left * scale, target.y + ascent * scale); return true;
        }
        function paint(view, state, item) {
          var letter = state['letter' + view.number], tone = state['tone' + view.number], record = item && store.get(item.url);
          var theme = state['theme' + view.number], themeSource = themeSources[theme];
          var themeRecord = themeSource && store.get(themeSource.url);
          var signature = [letter, tone, theme, item && item.url, record && record.state, record && record.revision, themeRecord && themeRecord.state, themeRecord && themeRecord.revision, root.dataset.scene].join('|');
          if (view.signature === signature) return view.painted;
          view.issue = '';
          if (view.fallback) view.fallback.hidden = true;
          try {
            if (!view.context) throw new Error('No canvas');
            if (!record || record.state !== 'ready') throw new Error('Not ready');
            var source = bounds(item, record), target = source && containAtBaseline(source.width, source.height, view.canvas.width, Math.min(700, view.canvas.height), item.supportRatio);
            if (!target) throw new Error('Invalid crop');
            view.context.clearRect(0, 0, view.canvas.width, view.canvas.height);
            view.context.filter = 'none'; view.context.globalAlpha = 1; view.context.globalCompositeOperation = 'source-over';
            view.context.drawImage(record.image, source.x, source.y, source.width, source.height, target.x, target.y, target.width, target.height);
            view.button.dataset.themeDetails = String(win.FASGardenCharms?.draw(view.context, theme, target, view.canvas.width, view.canvas.height, themeRecord, themeSource) || 0);
            view.button.dataset.previewTheme = theme;
            // A low-strength directional light pass preserves the chosen flower palette,
            // including coloured detail in cream flowers; never use greyscale or hue rotation.
            if (view.context.createLinearGradient) {
              var reverse = root.dataset.scene === '3', ambient = root.dataset.scene === '1' ? .065 : .10;
              var light = view.context.createLinearGradient(reverse ? target.x + target.width : target.x, target.y, reverse ? target.x : target.x + target.width, target.y + target.height);
              light.addColorStop(0, 'rgba(255,226,175,.035)'); light.addColorStop(.42, 'rgba(184,139,95,.025)'); light.addColorStop(1, 'rgba(55,35,21,' + ambient + ')');
              view.context.globalCompositeOperation = 'source-atop'; view.context.fillStyle = light;
              view.context.fillRect(0, 0, view.canvas.width, view.canvas.height); view.context.globalCompositeOperation = 'source-over';
            }
            if (view.contact) {
              var contactContext = view.contact.getContext('2d');
              if (contactContext) {
                var baseline = Math.min(700, view.canvas.height) * .93, band = Math.max(8, target.height * .022);
                contactContext.clearRect(0, 0, view.contact.width, view.contact.height);
                contactContext.globalCompositeOperation = 'source-over';
                contactContext.drawImage(view.canvas, 0, baseline - band, view.canvas.width, band * 1.35, 0, baseline - 2, view.contact.width, 10);
                contactContext.globalCompositeOperation = 'source-in'; contactContext.fillStyle = '#2f2118';
                contactContext.fillRect(0, 0, view.contact.width, view.contact.height);
                contactContext.globalCompositeOperation = 'source-over'; view.contact.hidden = false;
                view.button.dataset.contactReady = 'true';
              }
            }
            view.button.dataset.supportRatio = String(item.supportRatio || 1);
            if (view.cast) {
              var castContext = view.cast.getContext('2d');
              if (castContext) {
                castContext.clearRect(0, 0, view.cast.width, view.cast.height); castContext.globalCompositeOperation = 'source-over';
                castContext.drawImage(view.canvas, 0, 0, view.cast.width, view.cast.height);
                castContext.globalCompositeOperation = 'source-in'; castContext.fillStyle = '#352316'; castContext.fillRect(0, 0, view.cast.width, view.cast.height);
                castContext.globalCompositeOperation = 'source-over'; view.cast.hidden = false;
              }
            }
            view.painted = true; view.canvas.hidden = false;
            view.button.dataset.previewMethod = item.source === 'original' ? 'photographic' : 'photographic-library';
            view.button.dataset.previewTone = 'precolored'; view.button.dataset.previewSourceTone = tone;
          } catch (_) {
            if (view.contact) view.contact.hidden = true;
            delete view.button.dataset.contactReady;
            if (view.cast) view.cast.hidden = true;
            try { view.painted = typography(view, letter, tone); } catch (_) { view.painted = false; }
            view.canvas.hidden = !view.painted;
            view.button.dataset.previewMethod = view.painted ? 'typographic-fallback' : 'unavailable';
            view.button.dataset.previewTone = view.painted ? 'approximate' : 'unavailable'; view.button.dataset.previewSourceTone = '';
            view.issue = !view.painted ? 'unavailable' : !item ? 'missing' : record && ['queued', 'loading', 'retrying'].indexOf(record.state) >= 0 ? 'loading' : 'failed';
          }
          view.signature = signature; return view.painted;
        }
        function updateStatus(state, active) {
          var unavailable = active.filter(function (view) { return view.issue === 'unavailable'; });
          var failed = active.filter(function (view) { return view.issue === 'failed' || view.issue === 'missing'; });
          var loading = active.filter(function (view) { return view.issue === 'loading'; });
          function initials(list) { return list.map(function (view) { return state['letter' + view.number]; }).join(' y '); }
          var message = unavailable.length ? 'No se pudo mostrar la vista de ' + initials(unavailable) + '. Tu selección se conserva.' :
            failed.length ? 'No se pudo cargar el detalle floral de ' + initials(failed) + '. Mostramos la inicial simplificada; tu selección se conserva.' :
              loading.length ? 'Preparando el detalle floral de ' + initials(loading) + '…' : '';
          root.dataset.fgLetterQuality = unavailable.length ? 'unavailable' : message ? 'partial' : 'ready';
          root.dataset.previewLoaded = !message && active.length ? 'true' : 'partial';
          if (letterStatus) { letterStatus.textContent = message; letterStatus.hidden = !message; }
        }
        function update() {
          if (dead) return;
          var state = read(), signature = JSON.stringify(state), changed = signature !== selectionSignature;
          root.dataset.size = state.size; root.dataset.pair = String(state.pair);
          var active = views.filter(function (view) { return state.pair || view.number === '1'; });
          var integrated = usesIntegratedPhotograph(state, root.dataset.fgPhotoMode);
          function preserved(view) { return !integrated && root.dataset.fgPhotoMode === 'custom' && root.dataset[view.number === '1' ? 'fgPreservedOne' : 'fgPreservedTwo'] === 'true'; }
          var descriptors = new Map();
          if (!integrated) active.forEach(function (view) { if (!preserved(view)) descriptors.set(view, descriptorFor(entries, sources, state['letter' + view.number], state['tone' + view.number], doc.baseURI)); });
          var wanted = Array.from(descriptors.values()).filter(Boolean).map(function (item) { return item.url; });
          ['1', '2'].forEach(function (number) {
            if (number === '2' && !state.pair) return;
            var selectedTheme = themeSources[state['theme' + number]];
            if (selectedTheme) wanted.push(selectedTheme.url);
          });
          store.setWanted(wanted);
          views.forEach(function (view) {
            var letter = state['letter' + view.number], tone = state['tone' + view.number];
            view.button.setAttribute('aria-label', 'Editar ' + (view.number === '1' ? 'primera' : 'segunda') + ' inicial: ' + letter + ', tono ' + tone);
            view.canvas.setAttribute('aria-label', 'Vista orientativa: inicial ' + letter + ', ' + state.size + ' cm, tono ' + tone + '.');
            if (integrated || preserved(view)) {
              view.canvas.hidden = true; if (view.contact) view.contact.hidden = true; delete view.button.dataset.contactReady; if (view.fallback) view.fallback.hidden = true;
              if (view.cast) view.cast.hidden = true;
              view.signature = ''; view.issue = ''; view.button.dataset.previewMethod = integrated ? 'integrated-photo' : 'preserved-photo';
              view.button.dataset.previewTone = 'precolored'; view.button.dataset.previewSourceTone = tone;
            } else if (descriptors.has(view)) paint(view, state, descriptors.get(view));
          });
          notes.forEach(function (element) { element.textContent = state.message || DEFAULT_NOTE; element.dataset.length = state.message.length > 85 ? 'long' : state.message.length > 45 ? 'medium' : 'short'; });
          cards.forEach(function (element) { element.hidden = false; element.dataset.optional = String(!state.noteEnabled); element.setAttribute('aria-label', state.message ? 'Leer y editar dedicatoria: ' + state.message : 'Editar dedicatoria'); });
          counters.forEach(function (element) { element.textContent = String(state.messageLength); });
          updateStatus(state, active);
          if (integrated) root.dataset.previewLoaded = root.dataset.fgPhotoMode === 'integrated' ? 'true' : 'partial';
          selectionSignature = signature;
          var notify = broadcast && changed; broadcast = false;
          if (notify) root.dispatchEvent(new win.CustomEvent('fas:selection', { detail: { source: 'FASGardenLetters' } }));
        }
        function schedule(shouldBroadcast) {
          broadcast = broadcast || shouldBroadcast === true;
          if (dead || doc.hidden || frame !== null) return;
          frame = win.requestAnimationFrame(function () { frame = null; update(); });
        }
        function cleanup() {
          if (dead) return; dead = true;
          if (frame !== null) win.cancelAnimationFrame(frame);
          removers.splice(0).forEach(function (remove) { remove(); }); store.dispose(); controllers.delete(root);
        }
        controllers.set(root, { cleanup: cleanup, schedule: schedule, retry: store.retry, cancelFrame: function () { if (frame !== null) { win.cancelAnimationFrame(frame); frame = null; } } });
        listen(form, 'input', function () { schedule(true); }, removers);
        listen(form, 'change', function () { schedule(true); }, removers);
        listen(root, 'fas:selection', function (event) { if (!event.detail || event.detail.source !== 'FASGardenLetters') schedule(false); }, removers);
        listen(root, 'fas:preview-retry', store.retry, removers);
        owned('[data-fg-letter-retry]').forEach(function (button) { listen(button, 'click', store.retry, removers); });
        if (win.MutationObserver) {
          var photoObserver = new win.MutationObserver(function () { schedule(false); });
          photoObserver.observe(root, { attributes: true, attributeFilter: ['data-fg-photo-mode', 'data-scene', 'data-fg-preserved-one', 'data-fg-preserved-two'] });
          removers.push(function () { photoObserver.disconnect(); });
        }
        update();
      });
      return api;
    }
    function destroy(scope) {
      scope = scope || doc;
      controllers.forEach(function (controller, root) { if (scope === doc || scope === root || (scope.contains && scope.contains(root))) controller.cleanup(); }); return api;
    }
    function refreshSection(section, unloading) {
      var ancestors = Array.from(controllers.keys()).filter(function (root) { return root !== section && root.contains(section); });
      var outermost = ancestors.filter(function (root) { return !ancestors.some(function (other) { return other !== root && other.contains(root); }); });
      destroy(section); outermost.forEach(function (root) { destroy(root); initialize(root, unloading ? section : null); });
      if (!unloading && !outermost.length) initialize(section);
    }
    function dispose() { if (disposed) return; destroy(); disposed = true; globalRemovers.splice(0).forEach(function (remove) { remove(); }); }
    var api = { version: VERSION, initialize: initialize, destroy: destroy, dispose: dispose };
    listen(doc, 'shopify:section:load', function (event) { refreshSection(event.target, false); }, globalRemovers);
    listen(doc, 'shopify:section:unload', function (event) { refreshSection(event.target, true); }, globalRemovers);
    listen(doc, 'visibilitychange', function () { controllers.forEach(function (controller) { if (doc.hidden) controller.cancelFrame(); else controller.schedule(false); }); }, globalRemovers);
    listen(win, 'online', function () { controllers.forEach(function (controller) { controller.retry(); }); }, globalRemovers);
    if (doc.readyState === 'loading') listen(doc, 'DOMContentLoaded', function () { initialize(); }, globalRemovers); else initialize();
    return api;
  }
  return { version: VERSION, normalizedSelection: normalizedSelection, containAtBaseline: containAtBaseline, supportFromAlpha: supportFromAlpha, boundsFromAlpha: boundsFromAlpha, parseLibrary: parseLibrary, cutoutKey: cutoutKey, usesIntegratedPhotograph: usesIntegratedPhotograph, descriptorFor: descriptorFor, sourceRectangle: sourceRectangle, createImageStore: createImageStore, createRuntime: createRuntime };
});
